import axios from 'axios'
import { authHeader } from '../util/authHeader'
import { formService } from '../services/form-api.service.js'

const PROP_POLICY_NUMBER = "number";
const PROP_CLAIMANT_TITLE = "title";
const PROP_CLAIMANT_FIRSTNAME = "firstname";
const PROP_CLAIMANT_LASTNAME = "lastname";
const PROP_CLAIMANT_EMAIL = "email";
const PROP_CLAIMANT_DOB = "dateOfBirth";
const PROP_CLAIMANT_POLICYHOLDER = "policyholder";
const PROP_CLAIMANT_UKRESIDENT = "ukResident";
const PROP_CLAIMANT_VATREGISTERED = "vatRegistered";
const PROP_INCIDENT_TYPE_ID = "incidentTypeId";
const PROP_INCIDENT_TIME = "timeOfIncident";
const PROP_INCIDENT_DATE = "dateOfIncident";
const PROP_INCIDENT_DESCRIPTION = "descriptionOfIncident";
const PROP_INCIDENT_LOCATION = "locationOfIncident";
const PROP_INCIDENT_OCCURRED_ABROAD = "occurredAbroad";
const PROP_INCIDENT_TRIP_COUNTRY = "tripCountry";
const PROP_INCIDENT_TRIP_STARTDATE = "tripStartDate";
const PROP_INCIDENT_TRIP_ENDDATE = "tripEndDate";

export default {
  data () {
    return {
      insuranceLineType: 0,

      claimFormRef: null,

      policy: {},

      claimFormSaveMsg: null,
      isLoading: false,
      claimFormStage: null
    }
  },
  beforeMount () {

  },
  mounted () {

  },
  computed: {
    // ---------------------------------------------------------//
    // Returns the bottom(?) selected incident type
    // ---------------------------------------------------------//
    incidentType () {
      return this.selectedIncidentTypes.selectedIncidentType3 != null
        ? this.selectedIncidentTypes.selectedIncidentType3
        : this.selectedIncidentTypes.selectedIncidentType2 != null
          ? this.selectedIncidentTypes.selectedIncidentType2
          : this.selectedIncidentTypes.selectedIncidentType1 != null
            ? this.selectedIncidentTypes.selectedIncidentType1 : 0
    },

    // ---------------------------------------------------------//
    // Gets the stage / step number form the route param
    // ---------------------------------------------------------//
    stageNumber () {},
    // ---------------------------------------------------------//
    // Is the top level incident type AD
    // ---------------------------------------------------------//
    selectedIncidentTypeAD () {},
    // ---------------------------------------------------------//
    // Not realy fast trackable as there are other checks...
    // This is used to try and shorten the journey.
    // ---------------------------------------------------------//
    isFastTrackable () { },
    claimantEmail () {
      let { claimant } = this.$store.state.claimform.claimForm.data
      if (claimant) {
        return claimant.email
      }
      return null
    },
    claimformHasPolicyNumber () {
      const { policy } = this.$store.state.claimform.claimForm.data;
      if (policy && policy.hasOwnProperty(PROP_POLICY_NUMBER)) {
        if (policy[PROP_POLICY_NUMBER]) {
          return true;
        }
      }
      return false;
    },
    claimformHasClaimant () {
      const { claimant } = this.$store.state.claimform.claimForm.data;
      if (claimant && 
        claimant.hasOwnProperty(PROP_CLAIMANT_TITLE) && 
        claimant.hasOwnProperty(PROP_CLAIMANT_FIRSTNAME) && 
        claimant.hasOwnProperty(PROP_CLAIMANT_LASTNAME) && 
        claimant.hasOwnProperty(PROP_CLAIMANT_EMAIL) && 
        claimant.hasOwnProperty(PROP_CLAIMANT_DOB) && 
        claimant.hasOwnProperty(PROP_CLAIMANT_POLICYHOLDER)) {
        if (claimant[PROP_CLAIMANT_TITLE] &&
            claimant[PROP_CLAIMANT_FIRSTNAME] &&
            claimant[PROP_CLAIMANT_LASTNAME] &&
            claimant[PROP_CLAIMANT_EMAIL] &&
            claimant[PROP_CLAIMANT_DOB] &&
            typeof claimant[PROP_CLAIMANT_POLICYHOLDER] === 'boolean') {
          return true;
        }
      }
      return false;
    },
    claimformHasIncidentType () {
      const { incident } = this.$store.state.claimform.claimForm.data;
      if (incident && incident.hasOwnProperty(PROP_INCIDENT_TYPE_ID)) {
        if (incident[PROP_INCIDENT_TYPE_ID]) {
          return true;
        }        
      }
      return false;
    },
    claimformHasClaimantUKRes () {
      const { claimant } = this.$store.state.claimform.claimForm.data;
      if (claimant && 
        claimant.hasOwnProperty(PROP_CLAIMANT_UKRESIDENT)) {
        if (typeof claimant[PROP_CLAIMANT_UKRESIDENT] === 'boolean') {
          return true;
        }
      }
      return false;
    },
    claimformHasClaimantVATReg () {
      const { claimant } = this.$store.state.claimform.claimForm.data;
      if (claimant && 
        claimant.hasOwnProperty(PROP_CLAIMANT_VATREGISTERED)) {
        if (typeof claimant[PROP_CLAIMANT_VATREGISTERED] === 'boolean') {
          return true;
        }
      }
      return false;
    },
    claimformHasIncidentDetails () {
      const { data } = this.$store.state.claimform.claimForm;
      const { incident } = data;

      if (false) {
        console.log("DEBUG: claimformHasIncidentDetails");
        console.log("PROP_INCIDENT_TYPE_ID : ", PROP_INCIDENT_TYPE_ID);
        console.log("PROP_INCIDENT_TIME : ", PROP_INCIDENT_TIME);
        console.log("PROP_INCIDENT_DATE : ", PROP_INCIDENT_DATE);
        console.log("PROP_INCIDENT_DESCRIPTION : ",PROP_INCIDENT_DESCRIPTION);
        console.log("PROP_INCIDENT_LOCATION : ", PROP_INCIDENT_LOCATION);
        console.log("PROP_INCIDENT_OCCURRED_ABROAD : ", PROP_INCIDENT_OCCURRED_ABROAD);
        console.log("~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~")
        console.log("incident.hasOwnProperty(PROP_INCIDENT_TYPE_ID) : ",incident.hasOwnProperty(PROP_INCIDENT_TYPE_ID))
        console.log("incident.hasOwnProperty(PROP_INCIDENT_TIME) : ",incident.hasOwnProperty(PROP_INCIDENT_TIME))
        console.log("incident.hasOwnProperty(PROP_INCIDENT_DATE) : ",incident.hasOwnProperty(PROP_INCIDENT_DATE))
        console.log("incident.hasOwnProperty(PROP_INCIDENT_DESCRIPTION) : ",incident.hasOwnProperty(PROP_INCIDENT_DESCRIPTION))
        console.log("incident.hasOwnProperty(PROP_INCIDENT_LOCATION) : ",incident.hasOwnProperty(PROP_INCIDENT_LOCATION))
        console.log("data.hasOwnProperty(PROP_INCIDENT_OCCURRED_ABROAD) : ",data.hasOwnProperty(PROP_INCIDENT_OCCURRED_ABROAD))
        console.log("~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~")
        console.log("incident[PROP_INCIDENT_TYPE_ID] : ",incident[PROP_INCIDENT_TYPE_ID]);
        console.log("incident[PROP_INCIDENT_TIME] : ",incident[PROP_INCIDENT_TIME]);
        console.log("incident[PROP_INCIDENT_DATE] : ",  incident[PROP_INCIDENT_DATE]);
        console.log("incident[PROP_INCIDENT_DESCRIPTION] : ",incident[PROP_INCIDENT_DESCRIPTION]);
        console.log("incident[PROP_INCIDENT_LOCATION] : ",incident[PROP_INCIDENT_LOCATION]);
        console.log("typeof data[PROP_INCIDENT_OCCURRED_ABROAD] === boolean : ",typeof data[PROP_INCIDENT_OCCURRED_ABROAD] === 'boolean');
        console.log("~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~")
      }

      if (incident &&
        incident.hasOwnProperty(PROP_INCIDENT_TYPE_ID) &&
        incident.hasOwnProperty(PROP_INCIDENT_TIME) &&
        incident.hasOwnProperty(PROP_INCIDENT_DATE) &&
        incident.hasOwnProperty(PROP_INCIDENT_DESCRIPTION) &&
        incident.hasOwnProperty(PROP_INCIDENT_LOCATION) &&
        data.hasOwnProperty(PROP_INCIDENT_OCCURRED_ABROAD)) {
          if (incident[PROP_INCIDENT_TYPE_ID] &&
            incident[PROP_INCIDENT_TIME] &&
            incident[PROP_INCIDENT_DATE] &&
            incident[PROP_INCIDENT_DESCRIPTION] &&
            incident[PROP_INCIDENT_LOCATION] &&
            typeof data[PROP_INCIDENT_OCCURRED_ABROAD] === 'boolean') {
              if (data[PROP_INCIDENT_OCCURRED_ABROAD] === true) {
                if (!incident.hasOwnProperty(PROP_INCIDENT_TRIP_COUNTRY) ||
                !incident.hasOwnProperty(PROP_INCIDENT_TRIP_STARTDATE) ||
                !incident.hasOwnProperty(PROP_INCIDENT_TRIP_ENDDATE)) {   
                  return false;
                }
              }
          return true;
        }
      }
      return false;
    },
    claimformHasGadgets () {
      const { gadgets } = this.$store.state.claimform.claimForm.data;

      if (false) {
        console.log("DEBUG: claimformHasGadgets");
        console.log("gadgets : ", gadgets);
        console.log("Array.isArray(gadgets) : ", Array.isArray(gadgets));
        console.log("gadgets.length : ", gadgets.length);
      }
      
      if (gadgets && Array.isArray(gadgets) && gadgets.length > 0) {
        return true;
      }
      return false;
    },
    claimformHasDeclarations () {
      const { data } = this.$store.state.claimform.claimForm;
      if (false) {
        console.log("DEBUG: claimformHasDeclarations");
        console.log("data.hasOwnProperty(agreeDataProtection) : ", data.hasOwnProperty("agreeDataProtection"));
        console.log("data.hasOwnProperty(agreeDeclaration) : ", data.hasOwnProperty("agreeDeclaration"));
        console.log("data.hasOwnProperty(agreeFraud) : ", data.hasOwnProperty("agreeFraud"));

        console.log("typeof data[agreeDataProtection] === boolean : ", typeof data["agreeDataProtection"] === 'boolean');
        console.log("typeof data[agreeDeclaration] === boolean : ", typeof data["agreeDeclaration"] === 'boolean');
        console.log("typeof data[agreeFraud] === boolean : ", typeof data["agreeFraud"] === 'boolean');
      }

      if (data && 
        data.hasOwnProperty("agreeDataProtection") &&
        data.hasOwnProperty("agreeDeclaration") &&
        data.hasOwnProperty("agreeFraud")) {
          if (typeof data["agreeDataProtection"] === 'boolean' &&
          typeof data["agreeDeclaration"] === 'boolean' &&
          typeof data["agreeFraud"] === 'boolean') {
            return true;
          }
        }
        return false;
    }
  },
  methods: {
    // ---------------------------------------------------------//
    // Generates a new guid / uuid
    // ---------------------------------------------------------//
    newId () {
      const uuidv1 = require('uuid/v1')
      return uuidv1()
    },
    newIdv4 () {
      let uuidv4 = require('uuid/v4')
      
      return uuidv4()
    },
    // ---------------------------------------------------------//
    // Builds a claim form object from the child objects on
    // the component (claimant, gadgets, etc.)
    // ---------------------------------------------------------//
    buildClaimForm () {
      return this.claimForm
    },
    // ---------------------------------------------------------//
    // Saves the claim form object (server)
    // ---------------------------------------------------------//
    saveClaimForm (nextStep) {
      try {
        this.isLoading = true

        axios
          .post(this.saveClaimFormUrl, this.buildClaimForm(), { headers: authHeader() })
          .then(response => {
            if (response.data) {
              this.claimFormSaveMsg = 'Your claim form has been saved.'

              let apiRes = response.data

              //this.savedClaimForm = apiRes.data
              if (nextStep) { this.$router.push(nextStep) }
            }
          })
          // .catch(error => { })
          .finally(() => { this.isLoading = false })
      } catch (error) {
        this.isLoading = false
      }
    },
    // ---------------------------------------------------------//
    // Submits the completed claim form object (server)
    // ---------------------------------------------------------//
    submitClaimForm () {
      this.isLoading = true

      axios
        .post(this.submitClaimFormUrl, this.buildClaimForm(), { headers: authHeader() })
        .then(response => {
          if (response.data) {
            let { claimReference, passed, otCode, claimId, gadgetId } = response.data.data

            let incidentType = this.selectedIncidentTypeL1

            this.setSubmissionResponse({
              claimReference: claimReference,
              approved: passed,
              otCode: otCode,
              claimId: claimId,
              gadgetId: gadgetId,
              incidentType: incidentType //  HACK!
            })

            if (passed) {
              this.$store.commit('claimform/reset')

              this.setSubmissionResponse({
                claimReference: claimReference,
                approved: passed,
                otCode: otCode,
                claimId: claimId,
                gadgetId: gadgetId,
                incidentType: incidentType //  HACK!
              })

              this.$router.push({ path: 'approved' })
            } else {
              this.$store.commit('claimform/reset')

              this.setSubmissionResponse({
                claimReference: claimReference,
                approved: passed,
                otCode: otCode,
                claimId: claimId,
                gadgetId: gadgetId,
                incidentType: incidentType //  HACK!
              })

              this.$router.push({ path: 'thankyou' })
            }
          }
        })
        .finally(() => { this.isLoading = false })
    },
    submitClaimFormWithDelay () {
      //this.isLoading = true
      //set modal on 

      axios
        .post(this.submitClaimFormUrl, this.buildClaimForm(), { headers: authHeader() })
        .then(response => {
          if (response.data) {            
            let { claimReference, passed, otCode, claimId, gadgetId } = response.data.data
            let incidentType = this.selectedIncidentTypeL1

            this.setSubmissionResponse({
              claimReference: claimReference,
              approved: passed,
              otCode: otCode,
              claimId: claimId,
              gadgetId: gadgetId,
              incidentType: incidentType //  HACK!
            })

            if (passed) {
              this.$store.commit('claimform/reset')

              this.setSubmissionResponse({
                claimReference: claimReference,
                approved: passed,
                otCode: otCode,
                claimId: claimId,
                gadgetId: gadgetId,
                incidentType: incidentType //  HACK!
              })

              //this.$router.push({ path: 'approved' })
            } else {
              this.$store.commit('claimform/reset')

              this.setSubmissionResponse({
                claimReference: claimReference,
                approved: passed,
                otCode: otCode,
                claimId: claimId,
                gadgetId: gadgetId,
                incidentType: incidentType //  HACK!
              })

              //this.$router.push({ path: 'thankyou' })
            }
          }
        })
        .finally(() => { 
          //
          //this.isLoading = false 
        })
    },
    // ---------------------------------------------------------//
    //
    // ---------------------------------------------------------//
    getInprogressForms (pageNumber) {
      this.isLoading = true

      axios
        .get(this.baseUrl + '/api/v1/onlineclaim/standalone/partial/inprogress/' + pageNumber + '/10', { headers: authHeader() })
        .then(response => {
          if (response.data) {
            let apiRes = response.data

            if (apiRes.data) {
              this.setInProgressForms(apiRes.data)
            }
          }
        })

        .finally(() => { this.isLoading = false })
    },
    fetchCountries () {
      this.isLoading = true

      axios
        .get(this.baseUrl + '/api/v1/countries/')
        .then(response => {
          this.setCountries(response.data.data)
        })

        .finally(() => { this.isLoading = false })
    },
    handleNext (path, saveForm) {
      if (path) {
        if (saveForm) {
          this.saveClaimForm(path)
        } else {
          this.$router.push(path)
        }
      }
    },
    abandonForm (id, callback) {
      formService.deleteInProgressSingle(id)
        .then(() => {
          callback()
        })
    },
    registerNewUser (returnurl) {
      const { resellerId, claimantEmail } = this

      const { dispatch } = this.$store
      if (resellerId && claimantEmail) {
        dispatch('authentication/register', { resellerId, username: claimantEmail, autoLogin: true, returnurl })
          .then(() => {
            this.saveClaimForm()
          })
      }
    },
    gotoStage1 () {
      this.$router.push("/makeaclaim/1");
    }
  }
}
